module.exports = {
  language: 'Language',
  selectLanguage: 'Select Language',
  charging: 'Charging',
  notCharging: 'Not Charging',
  advanceSetting: 'Advance Setting',
  chargingDesc: 'Start charging when the battery level is lower than ',
  enabled: 'Enabled',
  disabled: 'Disabled',
  onPowerRestore: 'On Power Restore',
  powerWakeDesc: '** Please use two independent USB chargers to charge the Pi & PiSugar respectively, and keep the power switch of PiSugar on. It will automatically turn on when the external power is restored.',
  powerWakeDescFor3: 'PiSugar will automatically turn on when external power is restored.',
  powerWakeOffWarning: 'You have turned off the wake-on-power-restore function, please do not separately supply external power to the Raspberry Pi.',
  powerWakeOffTitle: 'Note',
  confirmButtonText: 'Confirm',
  wakeUpFeature: 'Schedule Wake Up',
  repeat: 'Repeat',
  repeatEveryday: 'repeat everyday.',
  repeatOn: 'repeat on',
  checkAll: 'Check All',
  clearAll: 'Clear All',
  wakeUpDesc: 'Schedule wake up at',
  wakeUpOffDesc: 'Schedule wake up off.',
  buttonFunction: 'Custom Button Function',
  singleTapLabel: 'Single Tap',
  doubleTapLabel: 'Double Tap',
  longTapLabel: 'Long Tap',
  singleTap: 'single tap',
  doubleTap: 'double tap',
  longTap: 'long tap',
  none: 'none',
  edit: 'Edit',
  customShell: 'Custom Shell',
  shutdown: 'Shutdown',
  shellModalTitle: {
    single: 'Shell to execute for single tap',
    double: 'Shell to execute for double tap',
    long: 'Shell to execute for long tap'
  },
  shell: 'Shell',
  shellPlaceholder: 'Input shell script here...',
  cancel: 'Cancel',
  confirm: 'Confirm',
  triggered: 'Triggered',
  safeShutdown: 'Safe Shutdown',
  batteryLevel: 'Battery Level',
  immediately: 'Immediately',
  secondsDelay: 'seconds delay',
  rtcTime: 'RTC Time',
  sysTime: 'SYS Time',
  syncTime: 'Sync Time',
  weekDay: {
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday'
  },
  weekDayShort: {
    Mon: 'Mon',
    Tue: 'Tue',
    Wed: 'Wed',
    Thu: 'Thu',
    Fri: 'Fri',
    Sat: 'Sat',
    Sun: 'Sun'
  },
  batteryInputProtect: 'Battery Input Protection',
  batteryInputProtectDesc: 'The charging process will stop when 60% ~ 80% of the battery is reached, which can effectively extend the battery life.',
  antiMistouch: 'Anti Mistouch',
  antiMistouchDesc: 'When the anti-mistouch is turned on, the switch needs to be clicked and held to trigger.',
  softPoweroff: 'Soft Shutdown',
  softPoweroffDesc: 'Using the switch button to shut down will not directly power off, the shutdown command will be issued by the software.',
  softPoweroffShell: 'Soft Shutdown Shell',
  softPoweroffShellDesc: 'Shell to execute when soft shutdown event is triggered.',
  changeLoginPassword: 'Change Login Password',
  username: 'Username',
  password: 'Password',
  passwordConfirm: 'Please enter password again',
  usernameCannotBeEmpty: 'Username cannot be empty',
  passwordCannotBeEmpty: 'Password cannot be empty',
  passwordNotConsistent: 'Two input password must be consistent',
  usernameWithSpace: 'Username cannot contain spaces',
  passwordWithSpace: 'Password cannot contain spaces',
  changePasswordSuccess: 'The modification is complete.',
  loginDialog: 'Login',
  login: 'Login'
}



// WEBPACK FOOTER //
// ./src/locale/en-US.js